import { Box } from '@material-ui/core';
import React from 'react';
import { InputItem } from './InputView.styled';
import TextField from '@material-ui/core/TextField';

const Inputview = ({ placeholder, params, value, onChange, bgColor }) => {
    return (
        <InputItem>
            <React.Fragment>
                <Box className="inputSearch" ref={params?.InputProps.ref} style={{backgroundColor:bgColor}}>
                    <div style={styles.inputDiv}>
                        {/* <img
                            src={SearchGrayInactive}
                            style={styles.imageStyle}
                        ></img> */}
                        {/* <input
                            placeholder={placeholder}
                            className="searchtStyle"
                            {...params?.inputProps}
                        /> */}
                        <TextField
                        id="receivesets-inputview-textfield"
                            {...params}
                            placeholder={placeholder}
                            inputProps={{
                                ...params?.inputProps,
                            }}
                            value={value}
                            onChange={onChange}
                        />
                    </div>
                </Box>
            </React.Fragment>
        </InputItem>
    );
};

const styles = {
    imageStyle: {
        height: '20px',
        width: '20px',
        marginLeft: '-5px',
        marginRight: '-5px',
    },
    inputDiv: { display: 'flex', alignItems: 'center'},
};
export default Inputview;
